import React from "react";
import { render } from "storyblok-rich-text-react-renderer";

const InsetTextTitle = (props) => {

    const blok = props.blok;

    return (
        <section className="width">

            <div className={`${blok.pad_top ? `pt-[84px] lg:mt-desktop-menu lg:pt-32` : `py-8 lg:py-9`} space-y-1 lg:space-y-20 space-x-4 lg:space-x-44 font-extralight`}>

                {blok.title != "" && blok.title != undefined && (
                    <h2 className="text-2xl lg:text-53 font-serif">
                        {blok.title}
                    </h2>
                )}
             {blok.copy != undefined && (
                    <div className="text-2xl lg:text-53 font-serif !leading-snug empty:hidden">
                        {render(blok.copy)}
                    </div>
                )}


            </div>

        </section>
    )
}

export default InsetTextTitle;